module.exports = __webpack_public_path__ + "img/3.b408f901.jpeg";